import { render, staticRenderFns } from "./FormDocumentLink.vue?vue&type=template&id=0a2d0cd5&"
import script from "./FormDocumentLink.vue?vue&type=script&lang=js&"
export * from "./FormDocumentLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports